import React, { useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Hero from './components/Hero';
import Services from './components/Services';
import Work from './components/Work';
import BackgroundSystem from './components/BackgroundSystem';
import CurvedDivider from './components/CurvedDivider';

// import Team from './components/Team';
import SectionNav from './components/SectionNav';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Lenis from 'lenis'
import MobileNav from './components/MobileNav';
import LogoCompetition from './components/LogoCompetition';
import WebsiteFeaturesSticky from './components/WebsiteFeaturesSticky';
import { Routes, Route, useLocation } from 'react-router-dom';

function App() {

  const { scrollY } = useScroll();
  const rotate = useTransform(scrollY, (value) => value / 3); // Continuous rotation: 1 degree per 3px scrolled

  const location = useLocation();
  const isLogoCompetition = location.pathname === '/website-competition';
  useEffect(() => {
    const lenis = new Lenis()

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    return () => {
      // Cleanup lenis instance if needed, though usually fine in App root
      lenis.destroy()
    }
  }, [])

  return (
    <div className="App selection:bg-white/10 selection:text-white relative">
      <BackgroundSystem />
      {!isLogoCompetition && <SectionNav />}
      <MobileNav showLinks={!isLogoCompetition} isLogoCompetition={isLogoCompetition} />
      {!isLogoCompetition && <WebsiteFeaturesSticky />}
      <div className="relative z-10">
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <div className="hidden lg:block">
                <CurvedDivider />
              </div>
              <Work />
              {/* <Team /> */}
              <Contact />
            </>
          } />
          <Route path="/website-competition" element={<LogoCompetition />} />
        </Routes>

        <Footer />
      </div>

      {/* Old Desktop Scroll To Top Gear - Hidden on Mobile now as it's in MobileNav */}
      {/* Kept for Desktop only if needed, or removed if MobileNav handles mobile and Desktop has none? 
          User said "make sure the gear... is also in that blurred section". 
          Implies desktop might still use the old one. 
          I will hide the old one on mobile (lg:flex, hidden on smaller).
      */}
      <div
        className={`fixed bottom-10 right-10 z-50 transition-all duration-500 transform hidden md:block`} // Added hidden md:block
      >
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} // Inline function since state logic removed for simplicity in snippet match
          className="relative w-16 h-16 flex items-center justify-center bg-transparent border-none outline-none group cursor-pointer"
          aria-label="Scroll to top"
        >
          {/* "TOP" Text - Positioned Above */}
          <span className="absolute -top-8 left-1/2 -translate-x-1/2 text-[10px] font-black text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none tracking-widest whitespace-nowrap">
            TOP
          </span>

          {/* Gear Icon with Scroll-Linked Rotation */}
          <motion.svg
            style={{ rotate }}
            className="w-full h-full text-white/30 group-hover:text-white transition-colors duration-300"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </motion.svg>
        </button>
      </div>
    </div>
  );
}

export default App;